import {Injectable} from "@angular/core";
import {GridLayoutService} from "@irb-common/interfaces/grid-layout.service";
import {DeleteCellComponent} from "@irb-common/components/grid/renderers/delete.cell.component";
import {DeleteHeaderComponent} from "@irb-common/components/grid/renderers/delete.header.component";
import {UtilityService} from "@irb-common/services/utility.service";
import {TruncateTooltipCellComponent} from "@irb-common/components/grid/renderers/truncatetooltip.cell.component";
import {CustomfilterComponent} from "@irb/irb-clients/portfolios/customfilter/customfilter.component";
import {IrbAgSetColumnFilterComponent} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-set-column-filter/irb-ag-set-filter.component";
import {RequiredTextboxEditor} from "@irb-common/components/grid/editors/required-textbox-editor";
import {MmcBillingDefaultsSettingsComponent} from "@irb/irb-settings/settings-mmc/mmc-billing-defaults-settings/mmc-billing-defaults-settings.component";
import {DropdownFilterRendererComponent} from "@irb-common/components/grid/renderers/dropdown-filter.cell.component";
import {NumberTextBoxEditorComponent} from "@irb-common/components/grid/editors/number-text-box-editor.component";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {NumberTextBoxRendererComponent} from '@irb-common/components/grid/renderers/number-text-box.cell.component';


@Injectable({
    providedIn: "root"
})
export class MmcSettingsBillingDefaultsGridLayoutService implements GridLayoutService<MmcBillingDefaultsSettingsComponent> {
    sizeFor: any;

    getFrameworkComponents(): any {
        return {
            "DeleteHeaderComponent": DeleteHeaderComponent,
            "DeleteCellComponent": DeleteCellComponent,
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent,
            "customFilterToolPanel": CustomfilterComponent,
            "irbAgSetColumnFilterComponent": IrbAgSetColumnFilterComponent,
            "RequiredTextboxEditor": RequiredTextboxEditor,
            "DropdownFilterRendererComponent": DropdownFilterRendererComponent,
            "NumberTextBoxEditorComponent": NumberTextBoxEditorComponent,
            "NumberTextBoxRendererComponent": NumberTextBoxRendererComponent
        };
    }

    constructor(private util: UtilityService) {
        this.sizeFor = {
            "Tier": 100
        };
    }

    getColumnDefs(parent: any) {
        return [{
            headerName: 'Tier',
            field: 'tierName',
            width: 100,
            minWidth: this.sizeFor.Tier,
            maxWidth: 120,
            resizable: false,
            comparator: this.util.sortString.bind(parent),
            cellRenderer: "cellRendererFormatter",
            cellHeight: 30,
            pinned: 'left'
        },
            {
                headerName: 'Range Max',
                field: 'rangeMax',
                width: 100,
                minWidth: 80,
                suppressMovable: true,
                cellClass: 'numberTextBoxCell',
                cellRenderer: "NumberTextBoxRendererComponent",
                cellRendererParams: (params: any) => {
                    return {
                        min: 0,
                        max: 100,
                        places: 2,
                        autoHeight: true,
                        disabled: parent.canEdit(params),
                        addZeroIfDotFirst: true,
                        onChange: (params: any, c: any) => {
                            if (params.data.rangeMax !== c.value && c.isValid) {
                                params.data.rangeMax = parseFloat(c.value);
                                params.api.redrawRows({rowNodes: [params.node]});
                                parent.onRangeUpdate();
                            }
                        }
                    };
                }
            },
            {
                headerName: 'Schwab Value',
                field: 'tdaPercentOfNER',
                width: 100,
                minWidth: 80,
                suppressMovable: true,
                cellClass: 'numberTextBoxCell',
                cellRenderer: "NumberTextBoxRendererComponent",
                cellRendererParams: () => {
                    return {
                        min: 0,
                        max: 100,
                        places: 2,
                        autoHeight: true,
                        addZeroIfDotFirst: true,
                        onChange: (params: any, c: any) => {
                            if (params.data.tdaPercentOfNER !== c.value && c.isValid) {
                                params.data.tdaPercentOfNER = parseFloat(c.value);
                                params.api.redrawRows({rowNodes: [params.node]});
                                parent.onTDAPercentOfNERUpdate();
                            }
                        }
                    };
                }
            },
            {
                headerName: 'Type',
                field: 'billingType',
                minWidth: 160,
                suppressMovable: true,
                cellClass: 'dropdownFilterCell',
                cellRenderer: 'DropdownFilterRendererComponent',
                cellRendererParams: (params: any) => {
                    return {
                        defaultValue: this.getDefaultBillingType(params.data.billingType),
                        values: [
                            {value: "NER", name: "NER%"},
                            {value: "BPS", name: "BPS"}
                        ],
                        onChange: (params: any, item: IDropdownItem) => {
                            params.data.billingType = item.value;
                            params.api.redrawRows({rowNodes: [params.node]});
                            parent.onBillingTypeChanged(params, item);
                        }
                    };
                }
            },

        ];
    }

    getDefaultBillingType(billingType: any) {
        let defaultValue: any;
        let values: any[] = [
            {value: "NER", name: "NER%"},
            {value: "BPS", name: "BPS"}
        ];
        let index = values.findIndex(x=>x.value === billingType);
        if(index >=0) {
            defaultValue = values[index];
        } else {
            defaultValue=  {name:'', value: ''}
        }
        return defaultValue;
    }

}
